// Mock 데이터를 사용한 단어 서비스
const MOCK_TRANSLATIONS = {
  'hello': { ko: '안녕하세요', ja: 'こんにちは' },
  'world': { ko: '세상', ja: '世界' },
  'learn': { ko: '배우다', ja: '学ぶ' },
  'study': { ko: '공부하다', ja: '勉強する' },
  'book': { ko: '책', ja: '本' },
  'school': { ko: '학교', ja: '学校' },
  'student': { ko: '학생', ja: '学生' },
  'teacher': { ko: '선생님', ja: '先生' },
  'language': { ko: '언어', ja: '言語' },
  'word': { ko: '단어', ja: '単語' },
  '안녕하세요': { en: 'hello', ja: 'こんにちは' },
  '세상': { en: 'world', ja: '世界' },
  '배우다': { en: 'learn', ja: '学ぶ' },
  '공부하다': { en: 'study', ja: '勉強する' },
  '책': { en: 'book', ja: '本' },
  '학교': { en: 'school', ja: '学校' },
  '학생': { en: 'student', ja: '学生' },
  '선생님': { en: 'teacher', ja: '先生' },
  '언어': { en: 'language', ja: '言語' },
  '단어': { en: 'word', ja: '単語' }
};

const MOCK_SIMILAR_WORDS = {
  'hello': ['hi', 'greeting', 'salutation', 'welcome'],
  'world': ['earth', 'globe', 'planet', 'universe'],
  'learn': ['study', 'acquire', 'gain', 'understand'],
  'study': ['learn', 'research', 'examine', 'investigate'],
  'book': ['novel', 'textbook', 'manual', 'publication'],
  'school': ['academy', 'institution', 'college', 'university'],
  'student': ['pupil', 'learner', 'scholar', 'apprentice'],
  'teacher': ['instructor', 'educator', 'professor', 'tutor'],
  'language': ['tongue', 'speech', 'dialect', 'communication'],
  'word': ['term', 'vocabulary', 'expression', 'phrase']
};

const MOCK_EXAMPLE_SENTENCES = {
  'hello': {
    text: 'Hello, how are you today?',
    translation: '안녕하세요, 오늘 어떻게 지내세요?'
  },
  'world': {
    text: 'The world is a beautiful place.',
    translation: '세상은 아름다운 곳입니다.'
  },
  'learn': {
    text: 'I want to learn a new language.',
    translation: '새로운 언어를 배우고 싶습니다.'
  },
  'study': {
    text: 'She studies hard every day.',
    translation: '그녀는 매일 열심히 공부합니다.'
  },
  'book': {
    text: 'This book is very interesting.',
    translation: '이 책은 매우 흥미롭습니다.'
  }
};

// DeepL API 대신 Mock 데이터 사용
export const translateWord = async (word, targetLang = 'ko') => {
  // 실제 구현에서는 DeepL API를 사용
  // const response = await fetch('https://api-free.deepl.com/v2/translate', {
  //   method: 'POST',
  //   headers: {
  //     'Authorization': `DeepL-Auth-Key ${process.env.REACT_APP_DEEPL_API_KEY}`,
  //     'Content-Type': 'application/x-www-form-urlencoded',
  //   },
  //   body: new URLSearchParams({
  //     text: word,
  //     target_lang: targetLang.toUpperCase()
  //   })
  // });

  return new Promise((resolve) => {
    setTimeout(() => {
      const normalizedWord = word.toLowerCase();
      const translation = MOCK_TRANSLATIONS[normalizedWord]?.[targetLang] ||
        `[${word}]의 ${targetLang} 번역을 찾을 수 없습니다.`;
      resolve(translation);
    }, 500);
  });
};

// AI 유사어 추출 (Mock 데이터 사용)
export const getSimilarWords = async (word) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const normalizedWord = word.toLowerCase();
      const similarWords = MOCK_SIMILAR_WORDS[normalizedWord] || [];
      resolve(similarWords);
    }, 300);
  });
};

// 예문 생성 (Mock 데이터 사용)
export const generateExampleSentence = async (word) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const normalizedWord = word.toLowerCase();
      const example = MOCK_EXAMPLE_SENTENCES[normalizedWord] || {
        text: `This is an example sentence with the word "${word}".`,
        translation: `"${word}"라는 단어가 포함된 예문입니다.`
      };
      resolve(example);
    }, 400);
  });
};

// 실제 DeepL API 연동 함수 (주석 처리)
/*
export const translateWordWithDeepL = async (word, targetLang = 'ko') => {
  try {
    const response = await fetch('https://api-free.deepl.com/v2/translate', {
      method: 'POST',
      headers: {
        'Authorization': `nureum_voca_0125 ${process.env.REACT_APP_DEEPL_API_KEY}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        text: word,
        target_lang: targetLang.toUpperCase()
      })
    });

    if (!response.ok) {
      throw new Error('Translation failed');
    }

    const data = await response.json();
    return data.translations[0].text;
  } catch (error) {
    console.error('DeepL API Error:', error);
    throw error;
  }
};
*/
